import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ConfigTabService } from './tab.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'configure-tab',
  templateUrl: './configure_tab.component.html',
  styleUrls: ['./configSection.css']
})
export class ConfigureTabComponent {

  paySlipIdResult = [];
  fieldTypes = [];

  TabName = '';
  TabKey = '';
  TabIdentifier = '';
  fieldName ='';
  tabSearch: any;
  tabModel = '';
  SelectedTabs = [];
  SelectedTabModel = '';

  TabExist = false;
  SelectedId = '';
  Tabs = ["Tab1", "Tab2", "Tab3", "Tab4"];
  collectionDetails = [];
  searchDataPafing = [];
  indexStart = 0;
  indexEnd = 10;
  pageSize = 4;
  pageNo = 1;
  totalPage = [1];
  buttonType = "Save";
  showEdit = false;
  showAdd = false;
  sectionSearchDisabled = true;
  public originalSectionsArray;
  public originalSelectedSectionArray;
  public searchSectionTab;
  public searchSelectedSectionValue;

  constructor(
    private tabService: ConfigTabService,
    private router: Router,
    private fb: FormBuilder,
    public toastr: ToastsManager, vcr: ViewContainerRef,
  ) {
    this.toastr.setRootViewContainerRef(vcr);
	this.originalSectionsArray =[];
	this.originalSelectedSectionArray =[];

    this.tabService
      .GetTabs()
      .subscribe(collectorObj => {

        this.paySlipIdResult = collectorObj;

        this.collectionDetails = [];
        this.searchDataPafing = [];
        this.collectionDetails = collectorObj;
        if (this.collectionDetails.length > 5) {
          let j = 1;
          for (var i = 0; i < this.collectionDetails.length; i++) {
            i = i + this.pageSize;
            j = j + 1;
            this.totalPage.push(j);
          }
        }
        for (var i = 0; i < this.collectionDetails.length; i++) {
          let arr = [];
          arr = this.collectionDetails[i];
          let rowNum = i;
          this.searchDataPafing.push({ arr, "row": rowNum });
        }
        this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
        this.indexEnd = (this.pageNo * this.pageSize);
      });
	  
	  this.tabService
      .GetSections()
      .subscribe(collectorObj => {
        this.Tabs = collectorObj;
        this.originalSectionsArray = collectorObj;
      });

  }
  moveRightTab() {
    for (var i = 0; i < this.tabModel.length; i++) {
      this.SelectedTabs.push(this.tabModel[i]);
      for (var j = this.Tabs.length - 1; j >= 0; j--) {
        if (this.Tabs[j] === this.tabModel[i]) {
          this.Tabs.splice(j, 1);
        }
      }
    }
    this.tabModel = '';
	if(this.SelectedTabs.length>0){
		this.sectionSearchDisabled = false;
		this.originalSelectedSectionArray = this.SelectedTabs;
	}
  }

  moveLeftTab() {
    for (var i = 0; i < this.SelectedTabModel.length; i++) {
      this.Tabs.push(this.SelectedTabModel[i]);
      for (var j = this.SelectedTabs.length - 1; j >= 0; j--) {
        if (this.SelectedTabs[j] === this.SelectedTabModel[i]) {
          this.SelectedTabs.splice(j, 1);
        }
      }
    }
    this.SelectedTabModel = '';
	if(this.SelectedTabs.length>0){
		this.sectionSearchDisabled = false;
		this.originalSelectedSectionArray = this.SelectedTabs;
	}else{
		this.sectionSearchDisabled = true;
	}
  }

  moveAllRightTab() {
    for (var i = 0; i < this.SelectedTabs.length; i++) {
      this.Tabs.push(this.SelectedTabs[i]);
    }
    this.SelectedTabs = this.Tabs;
    this.Tabs = [];
	if(this.SelectedTabs.length>0){
		this.sectionSearchDisabled = false;
		this.originalSelectedSectionArray = this.SelectedTabs;
	}
  }

  moveAllLeftTab() {
    for (var i = 0; i < this.Tabs.length; i++) {
      this.SelectedTabs.push(this.Tabs[i]);
    }
    this.Tabs = this.SelectedTabs;
    this.SelectedTabs = [];
	if(this.SelectedTabs.length>0){
		this.sectionSearchDisabled = false;
		this.originalSelectedSectionArray = this.SelectedTabs;
	}else{
		this.sectionSearchDisabled = true;
	}
  }

  pagingAgent(data) {
    this.pageNo = data;
    this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
    this.indexEnd = (this.pageNo) * this.pageSize;
  }

  changeItemsPerPage(data) {
    if (this.collectionDetails.length > 0) {
      this.totalPage = [1]
      let j = 1;
      for (var i = 0; i < this.collectionDetails.length; i++) {
        i = i + this.pageSize;
        j = j + 1;
        this.totalPage.push(j);
      }
    }
    else {
      this.totalPage = [];
    }
    this.pageSize = data;
    this.indexStart = 0;
    this.indexEnd = this.pageSize;
  }


  nameInputFormatter = (result: { name: string }) => result.name

  formatter = (result: { name: string }) => result.name

  searchByCode = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.paySlipIdResult.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));



  
  
  selected = (event) => {
    this.TabExist = false;
     this.showEdit = true;
    this.showAdd = false
    this.TabIdentifier = this.tabSearch.name;
    this.fieldName = this.tabSearch.name;
    for (var i = 0; i < this.paySlipIdResult.length; i++) {
      if (this.paySlipIdResult[i]["name"] == this.tabSearch.name) {
        this.TabExist = true;
        this.SelectedId = this.paySlipIdResult[i]["id"];
        setTimeout(() => {    //<<<---    using ()=> syntax
          this.TabExist = false;
        }, 3000);
      }
    }
    if (this.TabExist) {
		this.tabService
        .GetTabById(this.SelectedId)
        .subscribe(collectorObj => {
		  console.log(collectorObj);
          for (var i = 0; i < collectorObj["sectionIds"].length; i++) {
            for (var j = 0; j < this.Tabs.length; j++) {
              if (this.Tabs[j]["id"] == collectorObj["sectionIds"][i]) {
                this.SelectedTabs.push(this.Tabs[j]);
                this.Tabs.splice(j, 1);
              }
            }
          }
			if(this.SelectedTabs.length>0){
				this.sectionSearchDisabled = false;
				this.originalSelectedSectionArray = this.SelectedTabs;
			}
        });
    }
  }

  RowSelected = (event) => {
    this.TabIdentifier = event;
    this.buttonType = "Update";
    for (var i = 0; i < this.paySlipIdResult.length; i++) {
      if (this.paySlipIdResult[i]["name"] == event) {
        this.SelectedId = this.paySlipIdResult[i]["id"];
        this.fieldName = this.paySlipIdResult[i];
        setTimeout(() => {    //<<<---    using ()=> syntax
          this.TabExist = false;
        }, 3000);
      }
    }
  }

  ConfigFieldSubmit(configForm) {
	 let postSelectedSections = [];
	for (var i = 0; i < this.SelectedTabs.length; i++) {
	  postSelectedSections.push(this.SelectedTabs[i]["id"]);
	}
    if (this.SelectedId != "") {
      let data = {
        "Key": this.camelize(this.fieldName),
        "TabName": this.fieldName,
		"SectionIds": postSelectedSections,
        "Id": this.SelectedId,
      }
      this.tabService
        .EditTab(data)
        .subscribe(collectorObj => {
          if (collectorObj == 'Success') {
            this.toastr.success('Tab updated successfully.');
            this.SelectedId = '';
             configForm.reset();
			 setTimeout(()=>{  
					this.tabService
					  .GetTabs()
					  .subscribe(collectorObj => {

						this.paySlipIdResult = collectorObj;

						this.collectionDetails = [];
						this.searchDataPafing = [];
						this.collectionDetails = collectorObj;
						if (this.collectionDetails.length > 5) {
						  let j = 1;
						  for (var i = 0; i < this.collectionDetails.length; i++) {
							i = i + this.pageSize;
							j = j + 1;
							this.totalPage.push(j);
						  }
						}
						for (var i = 0; i < this.collectionDetails.length; i++) {
						  let arr = [];
						  arr = this.collectionDetails[i];
						  let rowNum = i;
						  this.searchDataPafing.push({ arr, "row": rowNum });
						}
						this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
						this.indexEnd = (this.pageNo * this.pageSize);
					  });
				}, 5000);
          }
          else {
            this.toastr.error('some error occured.');
          }
          //this.Groups = collectorObj;
        });
    }
    else {
		console.log(postSelectedSections);
      let data = {
        "Key": this.camelize(this.fieldName),
        "TabName": this.fieldName,
		"SectionIds": postSelectedSections
      }
      this.tabService
        .AddTabs(data)
        .subscribe(collectorObj => {
          if (collectorObj == 'Success') {
            this.toastr.success('Tab added successfully.');
            this.SelectedId = '';
             configForm.reset();
			 setTimeout(()=>{  
					this.tabService
					  .GetTabs()
					  .subscribe(collectorObj => {

						this.paySlipIdResult = collectorObj;

						this.collectionDetails = [];
						this.searchDataPafing = [];
						this.collectionDetails = collectorObj;
						if (this.collectionDetails.length > 5) {
						  let j = 1;
						  for (var i = 0; i < this.collectionDetails.length; i++) {
							i = i + this.pageSize;
							j = j + 1;
							this.totalPage.push(j);
						  }
						}
						for (var i = 0; i < this.collectionDetails.length; i++) {
						  let arr = [];
						  arr = this.collectionDetails[i];
						  let rowNum = i;
						  this.searchDataPafing.push({ arr, "row": rowNum });
						}
						this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
						this.indexEnd = (this.pageNo * this.pageSize);
					  });
				}, 5000);
          }
          else {
            this.toastr.error('some error occured.');
          }
          //this.Groups = collectorObj;
        });
    }
  }

  camelize = (str: string) => {
    return str
      .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
      .replace(/\s/g, '')
      .replace(/^(.)/, function ($1) { return $1.toLowerCase(); });
  }

  groupNameBlur = (event) => {
    this.TabIdentifier = event.target.value;
  }

  addNew(){
	this.SelectedId ='';
	this.tabSearch ='';
	this.fieldName ='';
	this.SelectedTabs=[];
	this.tabService
      .GetSections()
      .subscribe(collectorObj => {
        this.Tabs = collectorObj;
      });

    this.showEdit = false
    this.showAdd = true
  }
  searchSections(){
		let searchData = this.searchSectionTab;
		let searchResult = [];
		this.Tabs = this.originalSectionsArray;
		if(searchData){
			for(let i=0; i<this.Tabs.length;i++){
				if (this.Tabs[i]['name'].toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
					searchResult.push(this.Tabs[i]);
				}
			}
			this.Tabs=[];
			this.Tabs= searchResult;
		}else{
			this.Tabs = this.originalSectionsArray;
		}
	}
	searchSelectedSections(){
		let searchData = this.searchSelectedSectionValue;
		let searchResult = [];
		this.SelectedTabs = this.originalSelectedSectionArray;
		if(searchData){
			for(let i=0; i<this.SelectedTabs.length;i++){
				if (this.SelectedTabs[i]['name'].toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
					searchResult.push(this.SelectedTabs[i]);
				}
			}
			this.SelectedTabs=[];
			this.SelectedTabs= searchResult;
		}else{
			this.SelectedTabs = this.originalSelectedSectionArray;
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/configure_tab/configure_tab.comonent.ts